module.exports = __webpack_public_path__ + "static/media/faq-video-es-1080p.d099a9b0.mp4";